"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "children", "toggle"];
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/Modal/header.js";
var defaultProps = {};
function ModalHeader(_ref) {
  var className = _ref.className,
    children = _ref.children,
    toggle = _ref.toggle,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = (0, _classNames["default"])("modal-header bg-primary text-white", className);
  return /*#__PURE__*/_react["default"].createElement("div", Object.assign({}, rest, {
    className: classes,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 9
    }
  }), /*#__PURE__*/_react["default"].createElement("h5", {
    className: "modal-title",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 13
    }
  }, children), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-link close text-dark",
    onClick: toggle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 17
    }
  }, "\xD7")));
}
ModalHeader.defaultProps = defaultProps;
var _default = exports["default"] = ModalHeader;